(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yevanjel-turntable"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yv-turntable')) {
    customElements.define('yv-turntable', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.audio = this.querySelector('audio');
        if (!this.audio) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.power = this.querySelector('.yv-sound__power');
        this.volume = this.querySelector('input[type="range"]');
        this.status = this.querySelector('.yv-sound__status');
        this.intent = false;
        this.revision = 0;
        let saved = this.dataset.volume;
        try { saved = localStorage.getItem('yevanjel-sound-volume') ?? saved; } catch (error) {}
        const initial = Number(saved);
        this.volume.value = Number.isFinite(initial) ? Math.max(0, Math.min(100, initial)) : 35;
        this.setVolume(false);
        this.power.addEventListener('click', () => this.toggle(), options);
        this.listen = this.querySelector('[data-yv-sound-toggle]');
        if (this.listen) this.listen.addEventListener('click', () => this.toggle(), options);
        this.volume.addEventListener('input', () => this.setVolume(true), options);
        this.audio.addEventListener('playing', () => {
          if (!this.intent) { this.audio.pause(); return; }
          this.setState('playing');
        }, options);
        this.audio.addEventListener('pause', () => this.setState('idle'), options);
        this.audio.addEventListener('waiting', () => { if (this.intent) this.setState('loading'); }, options);
        this.audio.addEventListener('error', () => { this.intent = false; this.setState('error'); }, options);
        this.audio.addEventListener('timeupdate', () => {
          const seconds = Math.floor(this.audio.currentTime || 0);
          this.querySelector('.yv-sound__time').textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
          this.querySelector('.yv-sound__progress span').style.width = Number.isFinite(this.audio.duration) && this.audio.duration > 0 ? (this.audio.currentTime / this.audio.duration * 100) + '%' : '0%';
        }, options);
        this.addEventListener('yv-sound-stop', () => this.stop(), options);
        window.addEventListener('pagehide', () => this.stop(), options);
      }
      setVolume(persist) {
        const value = Number(this.volume.value);
        if (this.gain) {
          this.gain.gain.value = value / 100;
        } else {
          this.audio.volume = value / 100;
        }
        this.volume.style.setProperty('--yv-volume', value + '%');
        this.volume.setAttribute('aria-valuetext', value + '%');
        this.querySelector('output').textContent = value + '%';
        if (persist) { try { localStorage.setItem('yevanjel-sound-volume', String(value)); } catch (error) {} }
      }
      setState(state) {
        this.classList.toggle('is-playing', state === 'playing');
        this.dataset.state = state;
        this.status.textContent = this.dataset[state];
        this.power.setAttribute('aria-pressed', String(this.intent));
        this.power.setAttribute('aria-label', this.intent ? this.dataset.pause : this.dataset.play);
        if (this.listen) {
          this.listen.setAttribute('aria-pressed', String(this.intent));
          this.listen.querySelector('[data-yv-sound-action]').textContent = this.intent ? this.dataset.pauseShort : this.dataset.listen;
        }
      }
      async toggle() {
        if (this.intent) { this.stop(); return; }
        document.querySelectorAll('yv-turntable').forEach(player => {
          if (player !== this) player.dispatchEvent(new Event('yv-sound-stop'));
        });
        this.intent = true;
        const revision = ++this.revision;
        this.setState('loading');
        try {
          const AudioEngine = window.AudioContext || window.webkitAudioContext;
          if (!this.engine && AudioEngine) {
            this.engine = new AudioEngine();
            this.gain = this.engine.createGain();
            this.source = this.engine.createMediaElementSource(this.audio);
            this.source.connect(this.gain);
            this.gain.connect(this.engine.destination);
            this.audio.volume = 1;
            this.setVolume(false);
          }
          if (this.engine) await this.engine.resume();
          if (!this.intent || revision !== this.revision) return;
          if (this.audio.error) this.audio.load();
          await this.audio.play();
        } catch (error) {
          if (revision !== this.revision || !this.isConnected) return;
          this.intent = false;
          this.setState('error');
        }
      }
      stop() {
        this.intent = false;
        this.revision++;
        this.audio.pause();
        this.setState('idle');
      }
      disconnectedCallback() {
        if (!this.abort) return;
        this.stop();
        this.abort.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
